export default __webpack_public_path__ + "static/media/loopleft.8af2d9f9.gif";